import React from "react";
import MainNavigation from "./MainNavigation";
import NavBar from "./NavBar";
import { useAppContext } from "../../contexts/AppContext";

import "./Navigation.css";

const Navigation = () => {
  const { agentEntitlement } = useAppContext();

  return (
    <>
      <MainNavigation />
      {agentEntitlement ? <NavBar /> : null}
    </>
  );
};

export default Navigation;
